import { Color } from '@lsq-frontend/common-ui';

export class BankStatusInformation {
    public static Connected = {
        statusText: 'Connected',
        color: Color.Green,
        tooltip: 'Your account is connected.'
    };

    public static Disconnected = {
        statusText: 'Disconnected',
        color: Color.Red,
        tooltip:
            'The connection to your account has been interrupted; try reconnecting your account.'
    };
}

export const ACCOUNT_NUMBER_MIN_LENGTH = 6;
export const ACCOUNT_NUMBER_MAX_LENGTH = 16;
export const ROUTING_NUMBER_LENGTH = 9;
export const BANK_VERIFICATION_FILE_SIZE_LIMIT = 20; //MB

export enum SupportedBankCountry {
    UNITED_STATES,
    VIETNAM,
    CHINA,
    MALAYSIA,
    TAIWAN,
    HONG_KONG,
    INDIA,
    THAILAND,
    CANADA
}

export enum SupportedBankCountryCodes {
    UNITED_STATES = 'US',
    VIETNAM = 'VN',
    CHINA = 'CN',
    MALAYSIA = 'MY',
    TAIWAN = 'TW',
    HONG_KONG = 'HK',
    INDIA = 'IND',
    THAILAND = 'TH',
    CANADA = 'CA'
}

export enum SupportedBankTransferType {
    ACH,
    WIRE
}
